// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__nO37h","groups":"Skills_groups__NQuyG","group":"Skills_group__PXqOA","groupTitle":"Skills_groupTitle__Gdx9K"};